import { createStore } from 'vuex'

export default createStore({
    state: {
        pageTitle: '', // 页面标题
    },
    mutations: {
        setPageTitle(state, val) {
            state.pageTitle = val;
        }
    },
    actions: {
    },
    modules: {
    }
})
